import { ColDef, ColGroupDef } from "ag-grid-community/dist/lib/entities/colDef";
import { CsvExportParams, ExcelExportParams } from "ag-grid-enterprise";
import { ManagedCatalogueView } from "models/dbModels/nanagedCatalogues/ManagedCatalogue";
import { Link } from "react-router-dom";

export function getCatalogueSummaryConfig(): (ColDef<ManagedCatalogueView> | ColGroupDef<ManagedCatalogueView>)[] | null {        
    return [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "name",
            minWidth: 500,
            flex: 2,
            sort: "asc",       
            cellClass: "aggrid-header-link-lext cursor-pointer",
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                                children: <Link to={''} >{params.data?.name}</Link>,
                            }
                }
            }            
        },
        {
            headerName: "Created Date",
            field: "created",
            minWidth: 200,
            flex: 1,
            cellClass: 'dateField',
            valueGetter: (params) => params.data?.created? new Date(params.data?.created).toLocaleString('en-au',{ hour12: true })
                .replace(",","").toUpperCase(): null
        },
        {
            headerName: "Start Date",
            field: "startDate",
            minWidth: 200,
            flex: 1,
            cellClass: 'dateField',
            valueGetter: (params) => params.data?.startDate? new Date(params.data?.startDate).toLocaleString('en-au',{ hour12: true })
                .replace(",","").toUpperCase(): null
        },
        {
            headerName: "End Date",
            field: "endDate",
            minWidth: 200,
            flex: 1,
            cellClass: 'dateField',
            valueGetter: (params) => params.data?.endDate? new Date(params.data?.endDate).toLocaleString('en-au',{ hour12: true })
                .replace(",","").toUpperCase(): null
        }            
    ]
}

export function getCatalogueSummaryCsvDataFormatter(): CsvExportParams{
    const columnsWithDates = ["created","startDate","endDate"];
    return {
        fileName: "ManagedStock_" + new Date().toLocaleDateString('en-AU', {
            day : 'numeric',
            month : 'short',
            year : 'numeric',
            hour : '2-digit',
            minute : '2-digit'
        }).split(' ').join('-').replace(',', '') +".csv",
        columnKeys: ["name", "created","startDate","endDate"],
        processCellCallback: (cell) => {
              if (columnsWithDates.includes(cell.column.getColId()) && cell.value != null) {
                return (cell.value as String).split(' ')[0];
              }             
              return cell.value;
        },
    }
}
    


export function getCatalogueSummaryDataFormatter(): ExcelExportParams {
    const columnsWithDates = ["created","startDate","endDate"];
    return {
        processCellCallback: (cell) => {
            if (columnsWithDates.includes(cell.column.getColId()) && cell.value != null) {
            return (cell.value as String).split(' ')[0];
            }
            return cell.value;
        },
        sheetName: "Catalogues",
        columnKeys: ["name", "created","startDate","endDate"]
    }
}

// Export settings for Excel export
export function getCatalogueSummaryCoverPage(filterDetails: string): ExcelExportParams {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    };
    const formattedDate = now.toLocaleString('en-US', options);
    return {       
      prependContent: [
          {
            cells: [
              { data: { type: "String", value: "Details" }, styleId: "header" }
            ]
          },
          {
            cells: [
              { data: { type: "String", value: "Name:" } },
              { data: { type: "String", value: "Catalogues" } }
            ]
          },         
          {
            cells: [
              { data: { type: "String", value: "Date Generated:" } },
              { data: { type: "String", value: formattedDate  } }
            ]
          }
        ],
        processHeaderCallback: () => "",
        processCellCallback: () => "",
        sheetName: "Details",
    }!;
  }